const fragmentsForm = {
  bindings: {
    selection: '<',
    fragments: '<',
    onFormSubmit: '&',
    hasEdit: '<',
    isLocked: '<',
  },
  templateUrl:
    '/modules/pis-tool/fragments/fragments-form/fragments-form.html',
  controller: 'FragmentsFormController',
};

angular
  .module('pis-tool.module')
  .component('fragmentsForm', fragmentsForm);
